import { ref } from 'vue'
export function useChat() {
  const idComment = ref('')
  const sendMessage = ref(false)
  const stopScroll = ref(false)

  const scrollMessage = async (scroller: HTMLElement, scrollTop: number) => {
    if (!idComment.value || stopScroll.value) {
      sendMessage.value = false
      scroller.scrollTop = scrollTop
      return
    }

    const element = document.getElementById(idComment.value)
    if (!element) return

    stopScroll.value = true
    const elementPosition = element.offsetTop - scroller.offsetTop
    scroller.scrollTo({ top: elementPosition, behavior: 'smooth' }) // scroll to chat message in chat area
    setTimeoutScroll(element) // viewport scroll to chat message
  }

  const setTimeoutScroll = (element: HTMLElement, time: number = 1000) => {
    setTimeout(() => {
      const header = document.querySelector('header') as HTMLElement
      const headerHeight = header.offsetHeight
      const padding = 10 // distance expected to header

      if (element) {
        const rect = element.getBoundingClientRect()

        // rect.top: distance from element to top edge of viewport (not relative to document).
        // want to scroll so that the top of the element is below the header (header padding pixels).
        const targetY = rect.top - headerHeight - padding

        window.scrollTo({
          top: targetY,
          behavior: 'smooth',
        })
      }
    }, time)
  }

  return {
    idComment,
    sendMessage,
    stopScroll,
    scrollMessage,
    setTimeoutScroll,
  }
}
